// extracted by mini-css-extract-plugin
var _1 = "UB6TYern8Wuv24nTQei3";
var _2 = "_4OZWZnREixnMMUPgQXB";
var _3 = "clX2iFt_LoU2dgK16OFA";
export { _1 as "container", _2 as "contentContainer", _3 as "h2" }
